(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lumora-screenshot-match"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=s=>{const roots=s.querySelectorAll?s.querySelectorAll('#lumora-home'):[];roots.forEach(root=>{const track=root.querySelector('.lm-track');if(!track||track.dataset.ready==='true')return;const items=[...track.querySelectorAll('.lm-hero-product')];if(items.length<=3)return;track.dataset.ready='true';let i=0,t;const move=()=>{const w=items[0].getBoundingClientRect().width,g=parseFloat(getComputedStyle(track).gap)||0;i++;track.style.transform='translate3d(-'+(i*(w+g))+'px,0,0)';if(i>=items.length-3)window.setTimeout(()=>{track.style.transition='none';i=0;track.style.transform='translate3d(0,0,0)';requestAnimationFrame(()=>requestAnimationFrame(()=>track.style.transition='transform .65s cubic-bezier(.22,.61,.36,1)'))},700)};const start=()=>{clearInterval(t);t=setInterval(move,1000)};root.addEventListener('mouseenter',()=>clearInterval(t));root.addEventListener('mouseleave',start);root.addEventListener('touchstart',()=>clearInterval(t),{passive:true});root.addEventListener('touchend',start,{passive:true});start()})};init(document);document.addEventListener('shopify:section:load',e=>init(e.target))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
